$(document).ready(function(){
        $('.acoton > a').click(function(e) {
          $(this).toggleClass('active');
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass('show')) {
            $this.next().removeClass('show');
            $this.next().slideUp(350);
          } else {
            $this.parent().parent().find('.content').removeClass('show');
            $this.parent().parent().find('.content').slideUp(350);
            $this.next().toggleClass('show');
            $this.next().slideToggle(350);
          }
        });   
      });


 
	
             

              